module.exports = __webpack_public_path__ + "static/media/piper-2-background.f8692864.svg";